/**
 * Home/Landing page.
 */
import { Link } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'

export const Home: React.FC = () => {
  const { isSignedIn } = useAuth()

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-blue-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        {/* Hero Section */}
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold text-gray-900 mb-6">
            Welcome, Akos! Let's generate your report.
          </h1>

          {isSignedIn ? (
            <div className="flex justify-center space-x-4">
              <Link to="/generate" className="btn-primary px-8 py-3 text-lg">
                Generate Report
              </Link>
              <Link to="/samples" className="btn-secondary px-8 py-3 text-lg">
                Manage Samples
              </Link>
            </div>
          ) : (
            <div className="flex justify-center space-x-4">
              <Link to="/sign-up" className="btn-primary px-8 py-3 text-lg">
                Get Started
              </Link>
              <Link to="/sign-in" className="btn-secondary px-8 py-3 text-lg">
                Sign In
              </Link>
            </div>
          )}
        </div>

        {/* How It Works */}
        <div className="card max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-8">How It Works</h2>
          <div className="space-y-6">
            <div className="flex items-start">
              <div className="flex-shrink-0 w-8 h-8 bg-primary-600 text-white rounded-full flex items-center justify-center font-bold">
                1
              </div>
              <div className="ml-4">
                <h4 className="font-semibold text-lg">Upload Training Samples (Optional)</h4>
                <p className="text-gray-600">
                  Provide examples of your meeting notes and preferred report format. The AI learns your style.
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0 w-8 h-8 bg-primary-600 text-white rounded-full flex items-center justify-center font-bold">
                2
              </div>
              <div className="ml-4">
                <h4 className="font-semibold text-lg">Paste Your Meeting Notes</h4>
                <p className="text-gray-600">
                  Copy your handwritten or typed meeting notes into the generator.
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0 w-8 h-8 bg-primary-600 text-white rounded-full flex items-center justify-center font-bold">
                3
              </div>
              <div className="ml-4">
                <h4 className="font-semibold text-lg">Select Model & Generate</h4>
                <p className="text-gray-600">
                  Choose your AI model, configure reasoning effort if using GPT-5, and click generate.
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0 w-8 h-8 bg-primary-600 text-white rounded-full flex items-center justify-center font-bold">
                4
              </div>
              <div className="ml-4">
                <h4 className="font-semibold text-lg">Download Word Document</h4>
                <p className="text-gray-600">
                  Review your AI-generated report and download it as a formatted Word document.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
